import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


const __default__ = {
  name: 'ChapterContentComponent',
};

import { PropType } from 'vue';

import {
  ChapterData,
  Person as PersonType,
  Avatar as AvatarType,
  Prediction as PredictionType,
} from '@/types/chapter';

import Person from './Person.vue';
import Avatar from './Avatar.vue';
import Prediction from './Prediction.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  item: Object as () => ChapterData,
  transition: Function as PropType<(event: Event, id: string | number) => void>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.item && __props.item.type === 'person')
    ? (_openBlock(), _createBlock(Person, {
        key: 0,
        data: (__props.item as PersonType),
        click: __props.transition
      }, null, 8, ["data", "click"]))
    : (__props.item && __props.item.type === 'avatar')
      ? (_openBlock(), _createBlock(Avatar, {
          key: 1,
          data: (__props.item as AvatarType)
        }, null, 8, ["data"]))
      : (__props.item && __props.item.type === 'prediction')
        ? (_openBlock(), _createBlock(Prediction, {
            key: 2,
            data: (__props.item as PredictionType)
          }, null, 8, ["data"]))
        : _createCommentVNode("", true)
}
}

})